import { SEPARATOR_LENGTH } from "./constants";

export const truncateValues = (
  values: string[],
  isListView: boolean,
  maxProductCharactersLength: number,
  label: string = ""
) => {
  const displayedValues: string[] = [];
  let letterCount = label.length;

  for (const value of values) {
    const alphaLength = value.replace(/[^a-zA-Z]/g, "").length;
    const newLetterCount = letterCount + alphaLength + SEPARATOR_LENGTH;
    if (isListView && newLetterCount - SEPARATOR_LENGTH > maxProductCharactersLength) break;

    displayedValues.push(value);
    letterCount = newLetterCount;
  }

  return {
    displayedValues,
    restCount: values.length - displayedValues.length,
  };
};
